export default "/_next/static/src/assets/videos/dbb68b3b9aa967ebac194a77f140f33e.mp4";